import React from 'react';
import { ImageIcon, MessageSquareIcon, CodeIcon, PencilIcon, MusicIcon, VideoIcon, SparklesIcon, LightbulbIcon, ChefHatIcon } from 'lucide-react';
export const getIcon = (iconName: string) => {
  const iconMap: {
    [key: string]: React.ReactNode;
  } = {
    image: <ImageIcon className="h-6 w-6 text-white" data-id="element-2382" />,
    'message-square': <MessageSquareIcon className="h-6 w-6 text-white" data-id="element-2383" />,
    code: <CodeIcon className="h-6 w-6 text-white" data-id="element-2384" />,
    pencil: <PencilIcon className="h-6 w-6 text-white" data-id="element-2385" />,
    music: <MusicIcon className="h-6 w-6 text-white" data-id="element-2386" />,
    video: <VideoIcon className="h-6 w-6 text-white" data-id="element-2387" />,
    sparkles: <SparklesIcon className="h-6 w-6 text-white" data-id="element-2388" />,
    lightbulb: <LightbulbIcon className="h-6 w-6 text-white" data-id="element-2389" />,
    'chef-hat': <ChefHatIcon className="h-6 w-6 text-white" data-id="element-2390" />
  };
  return iconMap[iconName] || <ImageIcon className="h-6 w-6 text-white" data-id="element-2391" />;
};